export default __webpack_public_path__ + "static/media/crm-bar-chart.a1e2dfbe.png";